(function () {
  var STRIPS = [
    { strip: '.thumbnails', scroller: '.slider', active: '.slider__item.is-active .thumbnail', owner: 'slider__item' },
    { strip: '.gallery-viewer__thumbs', scroller: null, active: '.gallery-viewer__thumb--active .gallery-viewer__thumb-img', owner: 'gallery-viewer__thumb' },
    { strip: '.sp-kr-strip', scroller: null, active: '.sp-kr-thumb.is-active', owner: 'sp-kr-thumb' },
  ];

  function wire(strip, cfg) {
    var scroller = cfg.scroller ? strip.querySelector(cfg.scroller) : strip;
    if (!scroller || scroller.querySelector(':scope > .sp-thumb-indicator')) return;
    var bar = document.createElement('span');
    bar.className = 'sp-thumb-indicator';
    bar.setAttribute('aria-hidden', 'true');
    scroller.appendChild(bar);

    function place(instant) {
      var thumb = strip.querySelector(cfg.active);
      if (!thumb || !thumb.offsetWidth) { bar.classList.remove('sp-thumb-indicator--visible'); return; }
      if (instant || !bar.classList.contains('sp-thumb-indicator--visible')) instant = true;
      if (instant) bar.classList.add('sp-thumb-indicator--instant');
      var s = scroller.getBoundingClientRect();
      var t = thumb.getBoundingClientRect();
      var pile = thumb.parentElement;
      if (pile && pile.classList.contains('is-stack')) {
        var p = pile.getBoundingClientRect();
        t = { left: p.left, width: thumb.offsetWidth, bottom: p.top + thumb.offsetHeight };
      }
      bar.style.left = t.left - s.left + scroller.scrollLeft + 'px';
      bar.style.width = t.width + 'px';
      bar.style.top = t.bottom - s.top + scroller.scrollTop + 'px';
      bar.classList.add('sp-thumb-indicator--visible');
      if (instant) {
        void bar.offsetHeight;
        bar.classList.remove('sp-thumb-indicator--instant');
      }
    }

    place(true);
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        if (m[i].target.classList && m[i].target.classList.contains(cfg.owner)) { place(false); return; }
      }
    }).observe(strip, { subtree: true, attributes: true, attributeFilter: ['class'] });
    if (window.ResizeObserver) new ResizeObserver(function () { place(true); }).observe(scroller);
  }

  function init() {
    STRIPS.forEach(function (cfg) {
      document.querySelectorAll(cfg.strip).forEach(function (el) { wire(el, cfg); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  var queued = false;
  new MutationObserver(function (m) {
    if (queued) return;
    for (var i = 0; i < m.length; i++) {
      if (m[i].addedNodes.length) {
        queued = true;
        requestAnimationFrame(function () { queued = false; init(); });
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
